import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Badge, Tooltip } from '@chakra-ui/react';
import moment from 'moment/moment';
import 'moment/locale/is';

import { NotificationsEmail, TravelRequestResult } from 'api/types/types';

import { EMAIL_STATUS_MAPPER } from 'utils/emailUtils';

export const columns: ColumnDef<NotificationsEmail, any>[] = [
  {
    accessorKey: 'receiver',
    enableSorting: true,
    sortDescFirst: true,
    header: () => <span>Móttakandi</span>,
    cell: ({ getValue }): JSX.Element => {
      const receiver = getValue() as string;
      return <strong>{receiver}</strong>;
    },
  },
  {
    accessorKey: 'dateSent',
    enableSorting: true,
    sortDescFirst: true,
    accessorFn: (row) => row,
    sortingFn: (rowA: any, rowB: any): any => {
      const idA = rowA.getValue('dateSent').dateSent;
      const idB = rowB.getValue('dateSent').dateSent;
      return idA > idB ? 1 : idA < idB ? -1 : 0;
    },
    header: () => <span>Sendingardagur</span>,
    cell: ({ getValue }): JSX.Element => {
      const { dateSent } = getValue() as NotificationsEmail;
      return (
        <>
          <span>{moment(dateSent).format('DD. MMM. YYYY')}</span>{' '}
          <span style={{ color: '#999', paddingLeft: '10px' }}>
            kl. {moment(dateSent).format('hh:mm')}
          </span>
        </>
      );
    },
  },
  {
    accessorKey: 'shortName',
    enableSorting: false,
    header: () => <span>Tilkynning</span>,
    cell: ({ getValue }): JSX.Element => {
      const shortName = getValue() as string;
      return (
        <Tooltip>
          <Badge
            colorScheme={EMAIL_STATUS_MAPPER[shortName]?.color}
            cursor="pointer"
          >
            {EMAIL_STATUS_MAPPER[shortName]?.label}
          </Badge>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: 'success',
    enableSorting: true,
    header: () => <span style={{ width: '40px' }}>Staða</span>,
    cell: ({ getValue }): JSX.Element => {
      const success = getValue() as NotificationsEmail;

      return (
        <Tooltip
          label={
            success
              ? 'Tölvupóstur hefur verið sendur á netfang'
              : 'Tölvupóstur ekki sendur'
          }
        >
          <Badge colorScheme={success ? 'green' : 'red'} cursor="pointer">
            {success ? 'Tölvupóstur sendur' : 'Tölvupóstur ekki sendur'}
          </Badge>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: 'reference',
    enableSorting: true,
    sortDescFirst: true,
    header: () => <span>Vísun</span>,
    cell: ({ getValue }): JSX.Element => {
      const reference = getValue() as string;
      const ref = reference || (
        <span style={{ color: '#ccc' }}>Vísun ekki skráð</span>
      );
      return <>{ref}</>;
    },
  },
];
